export enum GenFavotitesDialogActionsEnum {
    DeleteItems = 'deleteItems',
    RemoveList = 'removeList',
    AddAll = 'addAll',
    Edit = 'edit',
    Create = 'create',
}